import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { ContactComponent } from './pages/contact/contact.component';
import { JobsComponent } from './pages/jobs/jobs.component';
import { JobComponent } from './pages/job/job.component';
import { AdvicesComponent } from './pages/advices/advices.component';
import { ServicesComponent } from './pages/services/services.component';
import { ApplicationComponent } from './pages/application/application.component';
import { LoginComponent } from './pages/login/login.component';
import { RegisterComponent } from './pages/register/register.component';
import { IsLoggedOut, IsLoggedIn } from './services/management/user/user.service';
import { ProfileComponent } from './pages/profile/profile.component';
import { ResumeComponent } from './pages/resume/resume.component';


const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  {
    path: 'advices',
    component: AdvicesComponent
  },
  {
    path: 'contact',
    component: ContactComponent
  },
  {
    path: 'jobs',
    component: JobsComponent,
  },
  {
    path: 'jobs/:id',
    component: JobComponent,
  },
  {
    path: 'jobs/:id/apply',
    component: ApplicationComponent,
  },
  {
    path: 'services',
    component: ServicesComponent
  },
  {
    path: 'profile',
    component: ProfileComponent,
    canActivate: [IsLoggedIn]
  },
  {
    path: 'resume',
    component: ResumeComponent,
    canActivate: [IsLoggedIn]
  },
  {
    path: 'login',
    component: LoginComponent,
    canActivate: [IsLoggedOut]
  },
  {
    path: 'register',
    component: RegisterComponent,
    canActivate: [IsLoggedOut]
  },
  {
    path: '**',
    redirectTo: '/'
  },
  {
    path: '*',
    redirectTo: '/'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
